// src/admin/pages/PlanModal.jsx — create/edit a credit plan (superadmin only).
import React, { useState, useEffect } from 'react';
import AdminModal from '../components/AdminModal.jsx';
import { adminCreatePlan, adminUpdatePlan } from '../adminApi.js';

const inputStyle = {
  width: '100%', padding: '10px 14px', borderRadius: '8px',
  border: '1px solid rgba(0,0,0,0.12)', background: '#ffffff',
  color: '#1d1d1f', fontSize: '14px', boxSizing: 'border-box',
  outline: 'none', fontFamily: "'DM Sans', sans-serif",
};
const labelStyle = { display: 'block', color: '#6c6c6d', fontSize: '13px', marginBottom: '6px', fontWeight: 500 };

export default function PlanModal({ open, plan, onClose, onSaved }) {
  const isEdit = !!plan;
  const [displayName, setDisplayName] = useState('');
  const [monthlyCredits, setMonthlyCredits] = useState('');
  const [active, setActive] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!open) return;
    setError('');
    setDisplayName(plan?.display_name || '');
    setMonthlyCredits(plan?.monthly_credits != null ? String(plan.monthly_credits) : '');
    setActive(plan?.active ?? true);
  }, [open, plan]);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      if (isEdit) {
        await adminUpdatePlan(plan.id, { display_name: displayName, monthly_credits: monthlyCredits, active });
      } else {
        await adminCreatePlan({ display_name: displayName, monthly_credits: monthlyCredits, active });
      }
      onSaved();
      onClose();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <AdminModal open={open} onClose={onClose} title={isEdit ? 'Modifica piano' : 'Crea piano'}>
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: '16px' }}>
          <label htmlFor="plan-name" style={labelStyle}>Nome piano</label>
          <input id="plan-name" type="text" value={displayName} onChange={e => setDisplayName(e.target.value)} required style={inputStyle} />
        </div>
        <div style={{ marginBottom: '16px' }}>
          <label htmlFor="plan-credits" style={labelStyle}>Crediti mensili</label>
          <input id="plan-credits" type="number" min="0" step="1" value={monthlyCredits}
            onChange={e => setMonthlyCredits(e.target.value)} required style={inputStyle} />
        </div>
        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '20px', fontSize: '13px', color: '#1d1d1f', cursor: 'pointer' }}>
          <input type="checkbox" checked={active} onChange={e => setActive(e.target.checked)} />
          Piano attivo
        </label>

        {error && (
          <div style={{ marginBottom: '16px', padding: '10px 14px', borderRadius: '8px', background: 'rgba(239,68,68,0.08)', border: '1px solid rgba(239,68,68,0.2)', color: '#EF4444', fontSize: '13px' }}>
            {error}
          </div>
        )}

        <button type="submit" disabled={loading} style={{
          width: '100%', padding: '10px', borderRadius: '8px', border: 'none',
          background: loading ? '#ccc' : '#E8002D', color: '#fff',
          fontSize: '14px', fontWeight: 600, cursor: loading ? 'not-allowed' : 'pointer',
        }}>
          {loading ? 'Salvataggio…' : (isEdit ? 'Salva modifiche' : 'Crea piano')}
        </button>
      </form>
    </AdminModal>
  );
}
